import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// The redesign's fonts (font-body, font-display, type-* in styles/tokens.css).
import "@fontsource-variable/inter";
import "./index.css";

// Light or dark follows the device (as the app does): the redesign's tokens
// flip under .dark on <html> (styles/tokens.css).
const darkQuery = window.matchMedia?.("(prefers-color-scheme: dark)");
const applyScheme = () => document.documentElement.classList.toggle("dark", !!darkQuery?.matches);
applyScheme();
darkQuery?.addEventListener?.("change", applyScheme);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);